export const INVALID_KEY_ERROR_CODE: number = 400;

export const FOOTER_NEWS_CONFIG: string = './news/config.json';

export const MANUALLY_LOAD_THRESHOLD: number = 20;



// WEBPACK FOOTER //
// ./src/sensefly.config.ts